import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserBlockComponent } from './user-block/user-block.component';
import { GenericBlockComponent } from './generic-block/generic-block.component';
import { CompanyBlockComponent } from './company-block/company-block.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    GenericBlockComponent,
    UserBlockComponent,
    CompanyBlockComponent
  ],
  exports: [
    GenericBlockComponent,
    UserBlockComponent,
    CompanyBlockComponent
  ]
})
export class BlocksModule { }



// WEBPACK FOOTER //
// ./client/app/shared/blocks/blocks.module.ts